import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Link } from '@alfa-bank/site-link';
import { Tooltip } from '@alfa-bank/site-tooltip-v2';

import type { TMenuItem, IDeps } from './models';
import { MenuItem as Component } from './menu-list-item';
import styles from './styles/styles.css';

export const MenuItem = createWidget<IDeps, TMenuItem>({ Link, Tooltip, styles })(Component);
